// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"2c98de0a","450":"b956d5f5","453":"dd0a80ec","586":"e43c141e","661":"47437456","714":"1c687674","732":"d4acc8e9","769":"03a17069","977":"4b87ad0d"}[chunkId] + ".chunk.js";
};